import { createApp } from 'vue'
import App from './Carmarket.vue'
import router from '@/router'
import store from '@/store'
import HelperPlugin from '@/plugins/HelperPlugin'
import VueLazyLoad from 'vue3-lazyload'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import DKToast from 'vue-dk-toast'

const toasterOptions = {
	duration: 4000,
	positionY: 'top',
	positionX: 'center',
	styles: {},
}

const cm = createApp(App)
	.use(store)
	.use(router)
	.use(HelperPlugin)
	.use(VueLazyLoad)
	.use(DKToast, toasterOptions)
	.use(VueReCaptcha, {
		siteKey: '6LcptdAbAAAAAGO3yakNaQWE_L-WzLyei1mW0Xpz',
		autoHideBadge: true,
	})
	.mount('#amd-main-content')
